import React from 'react';

const FeaturedBrands = () => {
  const mainBrands = [
    {
      name: 'Eastberg Gypsum',
      category: 'Gypsum Boards',
      url: 'https://clc.com.ph/eastberg/',
      logo: 'https://clc.com.ph/wp-content/uploads/2023/05/eastberg-logo.png',
      fallback: 'EASTBERG',
      colorFrom: 'from-green-500',
      colorTo: 'to-green-600',
      borderColor: 'border-green-200',
      hoverBorder: 'hover:border-green-400'
    },
    {
      name: 'Gardner Fibercement',
      category: 'Fibercement',
      url: 'https://clc.com.ph/gardner/',
      logo: 'https://clc.com.ph/wp-content/uploads/2023/05/gardner-logo.png',
      fallback: 'GARDNER',
      colorFrom: 'from-purple-500',
      colorTo: 'to-purple-600',
      borderColor: 'border-purple-200',
      hoverBorder: 'hover:border-purple-400'
    },
    {
      name: 'Main Paint',
      category: 'Paint Systems',
      url: 'https://clc.com.ph/main-paint/',
      logo: 'https://clc.com.ph/wp-content/uploads/2023/05/main-paint-logo.png',
      fallback: 'MAIN PAINT',
      colorFrom: 'from-red-500',
      colorTo: 'to-red-600',
      borderColor: 'border-red-200',
      hoverBorder: 'hover:border-red-400'
    },
    {
      name: 'Main PVC',
      category: 'PVC Ceiling',
      url: 'https://www.mainpvc.com',
      fallback: 'MAIN PVC',
      colorFrom: 'from-orange-500',
      colorTo: 'to-orange-600',
      borderColor: 'border-orange-200',
      hoverBorder: 'hover:border-orange-400'
    },
    {
      name: 'Geigher Steel Framing',
      category: 'Steel Framing',
      url: 'https://clc.com.ph/geigher/',
      logo: 'https://clc.com.ph/wp-content/uploads/2023/05/geigher-logo.png',
      fallback: 'GEIGHER',
      colorFrom: 'from-blue-500',
      colorTo: 'to-blue-600',
      borderColor: 'border-blue-200',
      hoverBorder: 'hover:border-blue-400'
    },
    {
      name: 'Main Tape',
      category: 'Joint Tape',
      url: 'https://www.maintape.com',
      fallback: 'MAIN TAPE',
      colorFrom: 'from-teal-500',
      colorTo: 'to-teal-600',
      borderColor: 'border-teal-200',
      hoverBorder: 'hover:border-teal-400'
    },
    {
      name: 'Main Putty',
      category: 'Joint Putty',
      url: 'https://www.mainputty.com',
      fallback: 'MAIN PUTTY',
      colorFrom: 'from-pink-500',
      colorTo: 'to-pink-600',
      borderColor: 'border-pink-200',
      hoverBorder: 'hover:border-pink-400'
    }
  ];

  const alternateBrands = [
    { name: 'ALT GYPSUM 1', category: 'Gypsum Alt 1', url: 'https://www.altgypsum1.com', colorFrom: 'from-green-400', colorTo: 'to-green-500', borderColor: 'border-green-200', hoverBorder: 'hover:border-green-400' },
    { name: 'ALT GYPSUM 2', category: 'Gypsum Alt 2', url: 'https://www.altgypsum2.com', colorFrom: 'from-green-500', colorTo: 'to-green-600', borderColor: 'border-green-200', hoverBorder: 'hover:border-green-400' },
    { name: 'ALT FIBER 1', category: 'Fiber Alt 1', url: 'https://www.altfiber1.com', colorFrom: 'from-purple-400', colorTo: 'to-purple-500', borderColor: 'border-purple-200', hoverBorder: 'hover:border-purple-400' },
    { name: 'ALT FIBER 2', category: 'Fiber Alt 2', url: 'https://www.altfiber2.com', colorFrom: 'from-purple-500', colorTo: 'to-purple-600', borderColor: 'border-purple-200', hoverBorder: 'hover:border-purple-400' },
    { name: 'ALT PAINT 1', category: 'Paint Alt 1', url: 'https://www.altpaint1.com', colorFrom: 'from-red-400', colorTo: 'to-red-500', borderColor: 'border-red-200', hoverBorder: 'hover:border-red-400' },
    { name: 'ALT PAINT 2', category: 'Paint Alt 2', url: 'https://www.altpaint2.com', colorFrom: 'from-red-500', colorTo: 'to-red-600', borderColor: 'border-red-200', hoverBorder: 'hover:border-red-400' },
    { name: 'ALT PVC 1', category: 'PVC Alt 1', url: 'https://www.altpvc1.com', colorFrom: 'from-orange-400', colorTo: 'to-orange-500', borderColor: 'border-orange-200', hoverBorder: 'hover:border-orange-400' },
    { name: 'ALT PVC 2', category: 'PVC Alt 2', url: 'https://www.altpvc2.com', colorFrom: 'from-orange-500', colorTo: 'to-orange-600', borderColor: 'border-orange-200', hoverBorder: 'hover:border-orange-400' },
    { name: 'ALT LGS 1', category: 'Steel Alt 1', url: 'https://www.altlgs1.com', colorFrom: 'from-gray-400', colorTo: 'to-gray-500', borderColor: 'border-gray-200', hoverBorder: 'hover:border-gray-400' },
    { name: 'ALT LGS 2', category: 'Steel Alt 2', url: 'https://www.altlgs2.com', colorFrom: 'from-gray-500', colorTo: 'to-gray-600', borderColor: 'border-gray-200', hoverBorder: 'hover:border-gray-400' },
    { name: 'ALT TAPE 1', category: 'Tape Alt 1', url: 'https://www.alttape1.com', colorFrom: 'from-teal-400', colorTo: 'to-teal-500', borderColor: 'border-teal-200', hoverBorder: 'hover:border-teal-400' },
    { name: 'ALT TAPE 2', category: 'Tape Alt 2', url: 'https://www.alttape2.com', colorFrom: 'from-teal-500', colorTo: 'to-teal-600', borderColor: 'border-teal-200', hoverBorder: 'hover:border-teal-400' }
  ];

  const BrandCard = ({ brand, isLarge = false }) => (
    <a 
      href={brand.url} 
      target="_blank" 
      rel="noopener noreferrer"
      className={`flex-1 block p-1 border ${brand.borderColor} rounded ${brand.hoverBorder} hover:shadow-md transition-all duration-200 bg-white`}
    >
      <div className={`w-full ${isLarge ? 'h-36' : 'h-12'} rounded flex items-center justify-center shadow-md overflow-hidden`}>
        {brand.logo ? (
          <img 
            src={brand.logo} 
            alt={brand.name} 
            className="w-full h-full object-contain p-2"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.parentElement.innerHTML = `<div class='w-full h-full bg-gradient-to-br ${brand.colorFrom} ${brand.colorTo} rounded flex items-center justify-center text-white font-bold ${isLarge ? 'text-sm' : 'text-xs'}'>${brand.fallback}</div>`;
            }}
          />
        ) : (
          <div className={`w-full h-full bg-gradient-to-br ${brand.colorFrom} ${brand.colorTo} rounded flex items-center justify-center text-white font-bold ${isLarge ? 'text-sm' : 'text-xs'}`}>
            {brand.fallback}
          </div>
        )}
      </div>
      <div className={`text-center mt-1 ${isLarge ? 'text-xs' : 'text-xs'} ${isLarge ? 'font-medium text-gray-700' : 'text-gray-600'}`}>
        {brand.category}
      </div>
    </a>
  );

  return (
    <div className="card p-3">
      <h3 className="font-semibold mb-3">FEATURED BRANDS</h3>
      <p className="note mb-3">Click on brand logos to visit their websites</p>
      
      <div className="grid gap-2">
        <div>
          <h4 className="font-medium mb-2 text-center">Main Brands</h4>
          <div className="flex gap-1 mb-1">
            {mainBrands.slice(0, 3).map(brand => (
              <BrandCard key={brand.name} brand={brand} isLarge={true} />
            ))}
          </div>
          <div className="flex gap-1">
            {mainBrands.slice(3).map(brand => (
              <BrandCard key={brand.name} brand={brand} isLarge={true} />
            ))}
          </div>
        </div>
        
        <div>
          <h4 className="font-medium mb-2 text-center">Alternate Brands</h4>
          <div className="flex gap-2 mb-2">
            <div className="flex-1 flex gap-1">
              {alternateBrands.slice(0, 2).map(brand => (
                <div key={brand.name} className="flex-1 block p-2 border border-green-200 rounded hover:border-green-400 hover:shadow-md transition-all duration-200 bg-white">
                  <a href={brand.url} target="_blank" rel="noopener noreferrer">
                    <div className={`w-full h-16 bg-gradient-to-br ${brand.colorFrom} ${brand.colorTo} rounded flex items-center justify-center text-white font-bold text-sm shadow-md`}>
                      {brand.name}
                    </div>
                    <div className="text-center mt-1 text-sm font-medium text-gray-700">{brand.category}</div>
                  </a>
                </div>
              ))}
            </div>
            <div className="flex-1 flex gap-1">
              {alternateBrands.slice(2, 4).map(brand => (
                <div key={brand.name} className="flex-1 block p-2 border border-purple-200 rounded hover:border-purple-400 hover:shadow-md transition-all duration-200 bg-white">
                  <a href={brand.url} target="_blank" rel="noopener noreferrer">
                    <div className={`w-full h-16 bg-gradient-to-br ${brand.colorFrom} ${brand.colorTo} rounded flex items-center justify-center text-white font-bold text-sm shadow-md`}>
                      {brand.name}
                    </div>
                    <div className="text-center mt-1 text-sm font-medium text-gray-700">{brand.category}</div>
                  </a>
                </div>
              ))}
            </div>
            <div className="flex-1 flex gap-1">
              {alternateBrands.slice(4, 6).map(brand => (
                <div key={brand.name} className="flex-1 block p-2 border border-red-200 rounded hover:border-red-400 hover:shadow-md transition-all duration-200 bg-white">
                  <a href={brand.url} target="_blank" rel="noopener noreferrer">
                    <div className={`w-full h-16 bg-gradient-to-br ${brand.colorFrom} ${brand.colorTo} rounded flex items-center justify-center text-white font-bold text-sm shadow-md`}>
                      {brand.name}
                    </div>
                    <div className="text-center mt-1 text-sm font-medium text-gray-700">{brand.category}</div>
                  </a>
                </div>
              ))}
            </div>
          </div>
          <div className="flex gap-1">
            {alternateBrands.slice(6).map(brand => (
              <BrandCard key={brand.name} brand={brand} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedBrands;